module.exports = __webpack_public_path__ + "img/video-29.3152abeb.png";